import React, { useState, useEffect } from 'react';
import { fetchBusinessInfo } from '../bridge';
import { IoStorefrontOutline } from 'react-icons/io5';
import '../styles/BusinessInfo.css';

const BusinessInfo = ({ userEmail, businessType }) => {
  const defaultLogo = require('../default_logo.jpeg');
  const [businessName, setBusinessName] = useState('');
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const previousBusinessInfo = await fetchBusinessInfo(userEmail);
        if (previousBusinessInfo) {
          setBusinessName(previousBusinessInfo.business_name || '');
          setLogoUrl(previousBusinessInfo.business_logo || null);
        }
      } catch (error) {
        console.error('Error fetching business info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userEmail]);

  const renderLogo = () => {
    return logoUrl ? logoUrl : defaultLogo;
  };

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return (
    <div className='business-info-container'>
      <img src={renderLogo()} alt="Business Logo" className='business-logo'/>
      <h1 className="business-name">{businessName}</h1>
      {businessType && (
        <div className="type-badge" aria-label={`Type: ${businessType}`}>
          {businessType}
        </div>
      )}
    </div>
  );
};

export default BusinessInfo;
